import type { Directive } from 'vue'
import { watch } from 'vue'

import { useRbacStore } from '@/stores/rbacStore'

/** Reactive permission check: usePermission().can('connectors:delete'). */
export function usePermission() {
  const rbac = useRbacStore()
  return {
    can: (key: string) => rbac.can(key),
    rbac
  }
}

const cleanups = new WeakMap<HTMLElement, () => void>()

/**
 * v-can="'connectors:delete'" — hides the element when the user lacks the
 * permission. Reactive: re-evaluates when permissions load/change.
 */
export const vCan: Directive<HTMLElement, string> = {
  mounted(el, binding) {
    const rbac = useRbacStore()
    const stop = watch(
      () => rbac.can(binding.value),
      (allowed) => {
        el.style.display = allowed ? '' : 'none'
      },
      { immediate: true }
    )
    cleanups.set(el, stop)
  },
  unmounted(el) {
    cleanups.get(el)?.()
    cleanups.delete(el)
  }
}
